import { BasePagedSearchCriteria } from "./BaseSearchCriteria";

export interface OrganizationSearchCriteria extends BasePagedSearchCriteria{

    name?:string;
    
}

export const ORGANIZATION_SEARCH_CRITERIA_KEY = 'OrganizationSearchCriteria';